import { Layout } from "antd";
import { AuthMethodsForm } from "features/auth";
import { AuthHeader } from "widgets/headers";

export const AuthMethodsPage = () => {
  return (
    <Layout>
      <AuthHeader />
      <Layout.Content
        style={{
          paddingTop: "13vh",
        }}
        className="auth-layout-content"
      >
        <AuthMethodsForm />
      </Layout.Content>
    </Layout>
  );
};
